
import { Component, Vue, Prop, Watch, Emit, Ref, Mixins } from 'vue-property-decorator'
import Qrcode from '@xt/www/components/showQrcode/index.vue'
import { ActivityGuideItem } from '@xt/client/types/home.d'
import { AjaxBasics } from '@xt/client/helpers/ajaxBasics'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'

@Component({
  components: {
    Qrcode,
    LazyImg
  }
})
export default class ActivityCard extends Mixins(MixinsHomeClick) {
  @Prop() dataSource: ActivityGuideItem & { currentYear: boolean }
  @Prop({ default: false }) crossYear: boolean

  @Ref() wrapper

  get tipsText() {
    const now = AjaxBasics.serviceDate
    return now.isAfter(this.dataSource.endTime) ? '已结束' : ''
  }

  handleClick() {
    if (this.dataSource.event) {
      this.onClickEvent(this.dataSource.event)
      return
    }
  }

  enterCard() {
    this.wrapper.style.transform = `translateY(-422px)`
  }

  leaveCard() {
    this.wrapper.style.transform = `translateY(0px)`
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
